import * as React from 'react';
import { RadioButtonGroup } from '@gandi/ui/deprecated';
import FormGroup from '../decorators/FormGroup';
import FormField from '../wrappers/FormField';
import decorateControl from '../wrappers/decorateControl';
import { jsx as _jsx } from "react/jsx-runtime";
const component = decorateControl(RadioButtonGroup, FormGroup);
const normalizeCheckboxesValues = props => (value, previousValue) => {
  if (props.type && props.type === 'checkbox') {
    if (Array.isArray(previousValue) && !Array.isArray(value)) {
      return previousValue;
    }
  }
  return value;
};
const RadioButtonGroupField = props => /*#__PURE__*/_jsx(FormField, {
  normalize: normalizeCheckboxesValues(props),
  ...props,
  component: component
});
export default RadioButtonGroupField;